/**
 * Format filter values for display (UI layer only)
 * 
 * This is the ONLY place where date formatting happens.
 * Separates display logic from query logic.
 */

import { parseISO, format, isValid } from 'date-fns';

/**
 * Format a date value for display
 * 
 * @param {{date: string, timezone: string}} value - Canonical date value
 * @returns {string} Formatted date string (e.g., "Jan 15, 2024")
 */
export function formatDateValue(value) {
  if (!value || typeof value !== 'object' || !value.date) {
    return String(value);
  }
  
  try {
    const date = parseISO(value.date);
    if (isValid(date)) {
      return format(date, 'MMM d, yyyy'); // e.g., "Jan 15, 2024"
    }
  } catch (e) {
    // Fallback to raw date string
  }
  
  return value.date;
}

/**
 * Format a filter value for display based on field type
 * 
 * @param {any} value - Filter value
 * @param {Object} fieldMeta - Field metadata
 * @returns {string} Formatted display string
 */
export function formatFilterValueForDisplay(value, fieldMeta) {
  if (fieldMeta?.kind?.toLowerCase() === 'date') {
    return formatDateValue(value);
  }
  
  if (typeof value === 'object' && value !== null) {
    // User objects
    return value.username || value.label || value.name || String(value);
  }
  
  return String(value);
}

